import { NgFor, NgIf, TitleCasePipe } from '@angular/common';
import { Component, OnInit, computed, signal } from '@angular/core';
import { AdvisorService } from '../../../_services/advisor/advisor.service';
import { InrShortPipe } from '../../../_pipes/indian-currency.pipe';
import { LoaderService } from '../../../_services/loader.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertyService } from '../../../_services/properties/property.service';
import { ToastService } from '../../../_services/toast.service';

export type AdvisorProfile = {
  _id: string;
  name: string;
  email: string;
  phone: string;
  password: string;
  priceUnit: string;
  alternativePhone: string;
  specialization: string;
  experience: string;
  location: string;
  consultationFee: string | number;
  aboutAdvisor: string;
  advisorImg: string;
  role: any;
  assignedProperty: string[];
  createdAt: string;
  updatedAt: string;
};

@Component({
  selector: 'app-profile',
  imports: [NgIf, NgFor,TitleCasePipe],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  providers:[InrShortPipe]
})
export class ProfileComponent implements OnInit {
  isAssign = signal(false);
  proRequests:any = signal([]);
  advisor = signal<AdvisorProfile | null>(null);
  assignedPro:any = []
  selectedAdvisorId = signal<string | null>(null);
  selectedPropReq = signal<any>({});
  isConfirmDisabled = computed(() => this.selectedAdvisorId() === null);
  advisorId:any = null
  constructor(
    private readonly _AS: AdvisorService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly loaderService: LoaderService,
    private readonly inrShortPipe: InrShortPipe,
    private readonly _PS: PropertyService,
    private readonly _NS: ToastService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const id = params['id'];
      if (id) {
        this.advisorId = id
        this.getAdvisor(id);
        this.getAllPropertyRequest()
      }
    });
  }

  async getAdvisor(id: any) {
    this.loaderService.show();
    this._AS.getAdvisor(id).subscribe(async (res: any) => {
      this.advisor.set(res.data);
      if (this.advisor()?.assignedProperty.length) {
        await this.getAssignedProperty({
          ids: this.advisor()?.assignedProperty,
        });
      }
      this.loaderService.hide();
    });
  }
  allproRequests:any =[]
  getAllPropertyRequest() {
    this._PS.getAllPropertyReq().subscribe({
      next: (res: any) => {
        if (res.status) {
          this.allproRequests = res.data
          this.proRequests.set(res.data);
        }
      },
      error: (err) => this._NS.error('Property Request not found'),
    });
  }

  selectAdvisor(property:any) {
    this.selectedPropReq.set(property);
    this.selectedAdvisorId.set(property.id);
  }

  onSearch(event: any) {
    const query = event.target.value.toLowerCase();
    const filtered = this.allproRequests.filter(
      (a: any) =>
        a.property?.name.toLowerCase().includes(query) ||
        a.property?.propertyType.toLowerCase().includes(query)
    );
    this.proRequests.set(filtered);
  }

  async getAssignedProperty(assigend: any) {
    await this._AS.getAssigendProperty(assigend).subscribe((res: any) => {
      this.assignedPro = res;
    });
  }

  viewDetails(property:any): void {
    this.router.navigate(['admin/property/details'], { 
      queryParams: { 
        id: property._id, 
        mode: 'details' 
      } 
    });
  }
  editAdvisor(advisorId:any): void {
    this.router.navigate(['admin/advisor/edit'], { 
      queryParams: { 
        id: advisorId, 
        mode: 'edit' 
      } 
    });
  }

  formatPriceDisplay(priceData: any): string {
    if (!priceData) return 'N/A';
    if (Array.isArray(priceData)) {
      if (priceData.length === 0) return 'N/A';
      const values = priceData
        .map((p) => Number(p.price))
        .filter((v) => !isNaN(v));
      if (values.length === 0) return 'N/A';

      const min = Math.min(...values);
      const max = Math.max(...values);
      if (values.length === 1 || min === max) {
        return this.inrShortPipe.transform(min);
      }
      return `${this.inrShortPipe.transform(
        min
      )} - ${this.inrShortPipe.transform(max)}`;
    }
    return this.inrShortPipe.transform(priceData);
  }

  assignProperty() {
    this.isAssign.set(true);
  }

  assignAdvisor(request: any) {
    this.selectedPropReq.set(request);
    this.isAssign.set(true);
  }

  closeModal() {
    this.isAssign.set(false);
  }

  confirmAdvisor() {
    const currentId = this.selectedAdvisorId();
    const selectedAdvisor = this.proRequests().find((a:any) => a.property.id === currentId);
    if (selectedAdvisor) {
      const payload = {
        advisorId:this.advisor()?._id,
        name: this.advisor()?.name,
        email: this.advisor()?.email,
        phone: this.advisor()?.phone,
        // password: this.advisor()?.password,
        property: {
          ...selectedAdvisor.property,
        },
      };
      this.loaderService.show();
      this._AS.assignAdvisor(payload).subscribe({
        next: (res) => {
          this.loaderService.hide();
          if (res.status) {
            this._NS.success(
              res.message || `Advisor ${payload.name} assigned successfully!`
            );
            this.ngOnInit()
            this.closeModal();
          } else {
            this._NS.error(res.message);
          }
        },
        error: (err) => {
          this.loaderService.hide();
          const specificError = Array.isArray(err.details)
            ? err.details[0]
            : err.message;
          this._NS.error(specificError);
          this.closeModal();
        },
      });
    }
  }
}
